// extracted by mini-css-extract-plugin
export var fullWidthBlock = "styles-module--fullWidthBlock--8f736";